export const logoUrl = "/logo.png?v=4";
